import useDocumentGenerationHandler, {
    DocumentGenerationContextData,
    DocumentGenerationType,
} from '../../document/useDocumentGenerationHandler'
import { useConst } from '@fluentui/react-hooks'
import * as UUID from 'uuid'
import { ReactElement } from 'react'
import { AxiosResponse } from 'axios'
import { QueueCallbacks } from '../../useQueueStateHandler'

/**
 * This is the form submission handler when we want to generate a report of some kind. It's the point of entry that
 * first creates the toast message.
 */
export default function useSubmitDocumentGenerationRequest<RequestT, StatusT = {}>(
    generationType: DocumentGenerationType,
    hookCallbacks?: QueueCallbacks<RequestT, StatusT, DocumentGenerationContextData>,
    allowMultiple?: boolean,
) {
    const requestId = useConst(() => UUID.v4())
    const handler = useDocumentGenerationHandler<RequestT, StatusT>()

    return (
        data: Omit<RequestT, 'generationType'>,
        title?: ReactElement | string,
        dispatchCallbacks?: QueueCallbacks<RequestT, StatusT, DocumentGenerationContextData>,
    ) => {
        handler.dispatch(allowMultiple ? UUID.v4() : requestId, {
            abortController: undefined,
            method: undefined,
            // The document generate endpoint produces only a UUID that represents the Azure SB message ID.
            mapDispatchResponse: (response: AxiosResponse<string>) => ({
                messageId: response.data,
                driveItem: undefined,
            }),
            generationType,
            url: '/document/generate',
            data: { ...data, generationType } as RequestT,
            title,
            callbacks: {
                ...(hookCallbacks || {}),
                ...(dispatchCallbacks || {}),
            },
        })
    }
}
